import styled from 'styled-components';

export const StyledBadgeItemContainer = styled.article`
  display: flex;
  margin-bottom: 4.6rem;
  gap: 1rem;
`;

export const StyledBadgeImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  min-width: 12.8rem;
  max-width: 12.8rem;
  height: 15rem;

  img {
    max-width: inherit;
  }
`;

export const StyledBadgeTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  width: 16.8rem;
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 19.6rem;
  }
`;

export const StyledBadgeTitleContainer = styled.div`
  margin-bottom: 0.6rem;
`;

export const StyledBadgeTitle = styled.p`
  font-size: 1.8rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.paragraph};
  line-height: 2.263rem;
  margin-bottom: 0.6rem;
`;

export const StyledBadgeDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 2.011rem;
  color: ${({ theme }) => theme.colors.paragraph};
`;
